import { Typography, useLocaleFormat } from '@eye-able/ui';
import { isToday } from 'date-fns';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { cn } from '@/helpers/cn';

type AuditDateProps = {
  date: Date | string | number;
  allowedTime?: string | null;
  className?: string;
};

export function AuditDate({ date, allowedTime, className }: AuditDateProps) {
  const { t } = useInlineTranslation();
  const { formatDate } = useLocaleFormat();
  const auditDate = new Date(date);

  return (
    <Typography
      tag='time'
      variant='body-s-highlight'
      dateTime={auditDate.toISOString()}
      className={cn('eye:whitespace-nowrap eye:font-bold', className)}
    >
      {isToday(auditDate) ? t('dateIsToday') : formatDate(auditDate, 'P')}
      {allowedTime && allowedTime !== '00:00:00'
        ? ` ${t('after')} ${allowedTime.slice(0, -3)}`
        : null}
    </Typography>
  );
}
